/**
 * Created by luka on 28.02.2018.
 */
import React from 'react';
import SelectableIcon from './SelectableIcon';
import {ListItem} from 'material-ui/List';

export default class SelectableListItem extends React.PureComponent {
	handleClick(id) {
		this.props.onPressItem(id);
	}

	render() {
		return (
			<ListItem
				style={{
					// class name has no effect for ListItem wrappers
					borderRadius: 25,
					backgroundColor: '#fff',
					padding: 0,
					marginBottom: this.props.hasBottomMargin ? 20 : 0,
				}}
				button
				onClick={() => this.handleClick(this.props.id)}
			>
				<div className='itemWrapper'>
					<div className='padded'>
						<SelectableIcon selected={this.props.selected} />
					</div>
					<div className='padded greyBorder'>
						<p className='levelTitle'>{this.props.title}</p>
						<p className='levelDesc'>{this.props.description}</p>
					</div>
				</div>
			</ListItem>
		);
	}
}



// WEBPACK FOOTER //
// ./src/level/SelectableListItem.js